module.exports = __webpack_public_path__ + "img/twitter.0f29cec1.svg";